import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { cn } from "@/shared/lib/utils";

// Remount (key by the value) to reset `copied` when a new value is shown.
export function CopyField({
  label,
  value,
  copyLabel,
  copiedLabel,
  monospace = false,
}: {
  label: string;
  value: string;
  copyLabel: string;
  copiedLabel: string;
  monospace?: boolean;
}) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
  };

  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <div className="flex gap-2">
        <Input
          readOnly
          value={value}
          className={cn("flex-1", monospace && "font-mono")}
          onFocus={(e) => e.currentTarget.select()}
        />
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={onCopy}
          disabled={copied}
          aria-label={copied ? copiedLabel : copyLabel}
        >
          {copied ? <Check /> : <Copy />}
        </Button>
      </div>
    </div>
  );
}
